import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

// reactstrap
import { Card, CardBody, CardTitle, Button, Row, Col, Form } from 'reactstrap'

// components
import TituloLogin from './components/TituloLogin';
import TextField from '../../components/TextField/TextField';


// helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie, setSessionCookie } from '../../helpers/cookies';


export default function Modulos({ acessos, handleReturn }) {
    const navigate = useNavigate();

    const { handleSubmit } = useForm({});

    // Submit do formulário, para validar a autenticação
    const onSubmit = (data) => {
        if (!modulo) {
            showMessage("Aviso", "Selecione a opção de acesso", "error");
            return;
        }

        if (modulo.value != "Gestor" && modulo.value != "Fiscal" && !acessoSelecionado) {
            showMessage("Aviso", "Selecione a opção de acesso", "error");
            return;
        }

        let _acesso = getSessionCookie();
        _acesso.acesso = {
            sigla: acessos.filter(f => f.modulo == modulo.value)[0].sigla,
            modulo: modulo.value
        }

        if (acessoSelecionado) {
            _acesso.acesso.acesso_id = acessoSelecionado.value;
            _acesso.acesso.acesso_descricao = acessos.filter(f => f.modulo == modulo.value)[0].acessos.filter(f => f.id == acessoSelecionado.value)[0].descricao;
        }

        setSessionCookie(_acesso);
        window.location = `/admin/inicio`;
    }

    // Lista de módulos para seleção
    const [optionsModulos, set_optionsModulos] = useState([]);

    // Módulo selecionado
    const [modulo, set_modulo] = useState("");

    //Change para o módulo selecionado
    const onChangeModulo = (e, select) => {
        set_acessoSelecionado("");

        set_modulo(e);
        if (e.value == "Gestor" || e.value == "Fiscal") {
            set_optionsAcessos([]);
        }
        let _acessos = acessos.filter(f => f.modulo == e.value)[0].acessos.map(m => {
            return { value: m.id, label: m.descricao }
        });

        set_optionsAcessos(_acessos);
    }

    // Lista de acessos do módulos selecionado
    const [optionsAcessos, set_optionsAcessos] = useState([]);
    const [acessoSelecionado, set_acessoSelecionado] = useState("");
    // Change para o acesso selecionado
    const onChangeAcesso = (e, select) => {
        set_acessoSelecionado(e);
    }

    useEffect(() => {
        const _modulos = acessos.map(acesso => {
            return { value: acesso.modulo, label: acesso.modulo }
        })
        set_optionsModulos(_modulos);
    }, []);

    return (
        <div>
            <Card style={{ marginTop: "10vh" }}>
                <CardBody >
                    <Row className='mt-3 pl-3'>
                        <Col lg='6' md='12' className='text-center d-flex flex-column justify-content-center'>
                            <TituloLogin></TituloLogin>
                        </Col>
                        <Col lg='6' md='12' className='text-left'>
                            <CardTitle tag={'h4'} className='fw-normal text-center'>Módulos de Acesso</CardTitle>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <TextField label={"* Módulo"} name={"modulo"} type={"select"} options={optionsModulos} value={modulo} onChange={onChangeModulo} searchable />
                                {optionsAcessos.length > 0 && <TextField label={"* Acesso"} name={"acesso"} type={"select"} options={optionsAcessos} value={acessoSelecionado} onChange={onChangeAcesso} searchable />}
                                <div className='text-center text-lg-start'>
                                    <a onClick={handleReturn} href="" className=" text-secondary">Voltar</a>
                                </div>
                                <div className="mt-3 d-flex justify-content-center justify-content-lg-end">
                                    <Button type="submit" color='success' className='fw-bold px-4' >
                                        Entrar
                                    </Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    )

}